"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinSettingsGroup = void 0;
/**
 * Class description
 *
 * Created: 2019-09-27
 * @author jonas
 */
const GuiLayout_1 = require("@nolimit/slot-launcher/bin/gui/utils/GuiLayout");
const gsap_1 = require("gsap");
class SpinSettingsGroup extends PIXI.Container {
    get separator() {
        return this._separator;
    }
    get autoPlayButton() {
        return this._autoPlayButton;
    }
    get fastSpinButton() {
        return this._fastSpinButton;
    }
    getWidth() {
        const aBefore = this._autoPlayButton.visible;
        const sBefore = this._separator.visible;
        const fBefore = this._fastSpinButton.visible;
        this._autoPlayButton.visible = true;
        this._separator.visible = true;
        this._fastSpinButton.visible = true;
        const width = this.width;
        this._autoPlayButton.visible = aBefore;
        this._separator.visible = sBefore;
        this._fastSpinButton.visible = fBefore;
        return width;
    }
    constructor(fastSpinButton, autoPlayButton) {
        super();
        this._autoPlayButton = autoPlayButton;
        this._separator = new PIXI.Graphics();
        this._fastSpinButton = fastSpinButton;
        this.addChild(this._autoPlayButton);
        this.addChild(this._separator);
        this.addChild(this._fastSpinButton);
        this._separator.clear();
        this._separator.lineStyle(1, 0xffffff, 0.6);
        this._separator.lineTo(0, this._fastSpinButton.height);
        this.resize();
        /*
        
                const paddingGfx = new PIXI.Graphics();
                paddingGfx.beginFill(0xff0000,0.1);
                paddingGfx.drawRect(0,0,this.width, this.height);
                paddingGfx.endFill();
        
                this.addChild(paddingGfx);
        
        */
        this.hideSeparator(0);
    }
    resize() {
        /*        const alignTheseItems = [this._autoPlayButton, this._separator,this._fastSpinButton];
                const filtered = [];
                for (let item of alignTheseItems){
                    if (item.parent == this){
                        filtered.push(item);
                    }
                }*/
        GuiLayout_1.GuiLayout.align(this.children, 18);
    }
    hideAutoPlay(duration) {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            new gsap_1.TweenLite(this._autoPlayButton, duration, { alpha: 0, ease: gsap_1.Linear.easeNone }),
            this.hideSeparator(duration)
        ]);
        tl.add(() => {
            this._autoPlayButton.visible = false;
        });
        return tl;
    }
    hideFastSpin(duration) {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            new gsap_1.TweenLite(this._fastSpinButton, duration, { alpha: 0, ease: gsap_1.Linear.easeNone }),
            this.hideSeparator(duration)
        ]);
        tl.add(() => {
            this._fastSpinButton.visible = false;
        });
        return tl;
    }
    showAutoPlay(duration) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => {
            this._autoPlayButton.visible = true;
        });
        tl.add([
            new gsap_1.TweenLite(this._autoPlayButton, duration, { alpha: 1, ease: gsap_1.Linear.easeNone }),
            () => { this.showSeparator(duration); }
        ]);
        return tl;
    }
    showFastSpin(duration) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => {
            this._fastSpinButton.visible = true;
        });
        tl.add([
            new gsap_1.TweenLite(this._fastSpinButton, duration, { alpha: 1, ease: gsap_1.Linear.easeNone }),
            () => { this.showSeparator(duration); }
        ]);
        return tl;
    }
    showSeparator(duration) {
        const tl = new gsap_1.TimelineLite();
        if (this.shouldShowSeparator()) {
            tl.add(() => {
                this._separator.visible = true;
            });
            tl.add([
                new gsap_1.TweenLite(this._separator, duration, { alpha: 1, ease: gsap_1.Linear.easeNone }),
            ]);
        }
        return tl;
    }
    hideSeparator(duration) {
        const tl = new gsap_1.TimelineLite();
        tl.add([
            new gsap_1.TweenLite(this._separator, duration, { alpha: 0, ease: gsap_1.Linear.easeNone }),
        ]);
        tl.add(() => {
            this._separator.visible = false;
        });
        return tl;
    }
    shouldShowSeparator() {
        if (this._autoPlayButton.visible && this._fastSpinButton.visible) {
            return true;
        }
        return false;
    }
}
exports.SpinSettingsGroup = SpinSettingsGroup;
//# sourceMappingURL=SpinSettingsGroup.js.map